import DesktopLayout from '../../../../components/layout/DesktopLayout';
import SystemBootstrap from '../../../../components/admin/SystemBootstrap';
import './index.css';

const SystemBootstrapPage = () => {
  return (
    <div className="admin-system-bootstrap-page">
      <DesktopLayout>
      <main className="admin-system-bootstrap-page__main">
        <div className="admin-system-bootstrap-page__container">
          <header className="admin-system-bootstrap-page__header">
            <h1 className="admin-system-bootstrap-page__title">系統管理 &gt; Bootstrap 工具</h1>
            <p className="admin-system-bootstrap-page__subtitle">
              快速重建測試環境資料
            </p>
          </header>
          <SystemBootstrap />
        </div>
      </main>
      </DesktopLayout>
    </div>
  );
};

export default SystemBootstrapPage;
